import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const dpeAzureCostAppPlugin = createPlugin({
  id: 'dpe-azure-cost-app',
  routes: {
    root: rootRouteRef,
  },
});

export const AzureCostCard = dpeAzureCostAppPlugin.provide(
  createRoutableExtension({
    name: 'AzureCostCard',
    component: () => import('./components/AzureCostCard').then((m) => m.AzureCostCard),
    mountPoint: rootRouteRef,
  }),
);
